import Vue from 'vue'
import Router from 'vue-router'
import Template from 'wino-template'
import AuthService from 'wicomp-auth'
import RewardsService from 'wimicro-rewards'
import RegistryService from 'wimicro-registry'
import TestService from '@/components/test'

Vue.use(Router)
let routes = [
  {
    path: '/user',
    component: () => import('@/components/layout/layout.vue'),
    name: 'User',
    children: [
      ...AuthService.sub_routes,
      ...RewardsService.sub_routes,
      ...RegistryService.sub_routes,
    ]
  }
]

// Import Registered Services
importServices([
  Template,
  AuthService,
  RewardsService,
  RegistryService,
  TestService
])

// Initialize Router
let router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  window.scroll({ top: 0, behavior: 'smooth' });
  // Event.$emit('loader:show', true)
  next()
})

async function importServices(services) {
  for (let i = 0; i < services.length; i++) {
    let service = services[i]
    routes = routes.concat(service.routes)
  }
}

export default router